export const createInitialUserValue = () => ({
    id: null,
    displayName: null,
    email: '',
    phoneNumber: '',
    firstName: '',
    lastName: '',
    isAdmin: false,
    isStaff: false,
    school: null,
    schoolRef: null,
    adminAccount: null
});
